import { render, staticRenderFns } from "./CodeIcon.vue?vue&type=template&id=06b5fd52&"
import script from "./CodeIcon.vue?vue&type=script&lang=js&"
export * from "./CodeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports